import React from "react"
import {Box} from "@mui/material"
import ContainerBox from "../../anwendungskonfigurator/content/container/ContainerBox"
import ContainerTab from "../../anwendungskonfigurator/content/container/ContainerTab"
import ContainerColumn from "../../anwendungskonfigurator/content/container/ContainerColumn"
import ContainerAccordion from "../../anwendungskonfigurator/content/container/ContainerAccordion"
import ContainerAccordionGroup from "../../anwendungskonfigurator/content/container/ContainerAccordionGroup"
import WidgetGrid from "../../anwendungskonfigurator/content/container/WidgetGrid"
import InfoBarWidgetList from "../../anwendungskonfigurator/content/container/InfoBarWidgetList"
import ContainerGrid from "../../anwendungskonfigurator/content/container/ContainerGrid"
import ContainerProduktsuche from "../../anwendungskonfigurator/content/container/ContainerProduktsuche"
import ContainerCentered from "../../anwendungskonfigurator/content/container/ContainerCentered"
import ContainerTable from "../../anwendungskonfigurator/content/container/ContainerTable"
import ContainerDragAndDrop from "../../anwendungskonfigurator/content/container/ContainerDragAndDrop"
import ContainerTableGrid from "../../anwendungskonfigurator/content/container/ContainerTableGrid"
import ContainerHoneycomb from "../../anwendungskonfigurator/content/container/ContainerHoneycomb"
import ContainerList from "../../anwendungskonfigurator/content/container/ContainerList"
import ColoredBoxContainer from "../../anwendungskonfigurator/content/container/ContainerColoredBox"
import ContainerDialog from "../../anwendungskonfigurator/content/container/ContainerDialog"
import ContainerFlex from "../../anwendungskonfigurator/content/container/ContainerFlex"
import ContainerStyledBox from "../../anwendungskonfigurator/content/container/ContainerStyledBox"
import ContainerPage from "../../anwendungskonfigurator/content/container/ContainerPage"
import ContainerPagination from "../../anwendungskonfigurator/content/container/ContainerPagination"
import PrintContainer from "./Container/PrintContainer"
import ContainerAccordionTable from "./../../anwendungskonfigurator/content/container/ContainerAccordionTable/ContainerAccordionTable"
import ContainerFlexList from "./../../anwendungskonfigurator/content/container/ContainerFlexList"
import ContainerObjectList from "./../../anwendungskonfigurator/content/container/ContainerObjectList"
import ContainerQSList from "../../anwendungskonfigurator/content/container/ContainerQSList"
import {ContainerManagedFlexContainer} from "../../anwendungskonfigurator/content/container/ContainerManagedFlex/ContainerManagedFlexContainer"
import {ContainerManagedFlexItem} from "../../anwendungskonfigurator/content/container/ContainerManagedFlex/ContainerManagedFlexItem"
import UnorderedListContainer from "../../anwendungskonfigurator/content/container/UnorderedListContainer"
import ContainerRootDrawer from "../../anwendungskonfigurator/content/container/ContainerRootDrawer"
import ContainerTabProgressHeader from "../../anwendungskonfigurator/content/container/ContainerTabProgressHeader"
import ContainerSortableList from "../../anwendungskonfigurator/content/container/ContainerSortableList"
import CardContainer from "../../anwendungskonfigurator/content/container/CardContainer"
import ContainerStyledTable from "../../anwendungskonfigurator/content/container/ContainerStyledTable"
import ContainerStyledTableGrid from "../../anwendungskonfigurator/content/container/ContainerStyledTableGrid"
import ContainerBausteinRef from "../../anwendungskonfigurator/content/container/ContainerBausteinRef"
import ContainerColumnLayout from "../../anwendungskonfigurator/content/container/ContainerColumnLayout"
import RootDialog from "../../anwendungskonfigurator/components/RootComponents/RootDialog"
import ContainerDropdown from "./Container/uwp-containers/ContainerDropdown"
import UnfallDynamicColumnTableContainer from "./Container/uwp-containers/UnfallDynamicColumnTableContainer"
import ContainerFlexTab from "../../anwendungskonfigurator/content/container/ContainerFlexTab"
import DragAndDropWrapper
    from "../../anwendungskonfigurator/content/widgets/DragAndDropWrapper/DragAndDropWrapper"

export const ContainerMap = Object.freeze({
    DRAGANDDROPWRAPPER: (props) => <DragAndDropWrapper {...props}/>,
    ACCORDION: (props) => <ContainerAccordion {...props} />,
    ACCORDIONGROUP: (props) => <ContainerAccordionGroup {...props} />,
    ACCORDIONTABLE: (props) => <ContainerAccordionTable {...props} />,
    BOX: (props) => <ContainerBox {...props} />,
    COLOREDBOX: (props) => <ColoredBoxContainer {...props} />,
    CENTERED: (props) => <ContainerCentered {...props} />,
    COLUMN: (props) => <ContainerColumn {...props} />,
    COLUMN_LAYOUT: (props) => <ContainerColumnLayout {...props} />,
    DRAGANDDROP: (props) => <ContainerDragAndDrop {...props} />,
    GRID: (props) => <ContainerGrid {...props} />,
    EMPTY: () => <Box height="100%" />,
    INFOBARWIDGETLIST: (props) => <InfoBarWidgetList {...props} />,
    PAGE: (props) => <ContainerPage {...props} />,
    PRODUKTSEARCH: (props) => <ContainerProduktsuche {...props} />,
    QSLIST: (props) => <ContainerQSList {...props} />,
    LIST: (props) => <ContainerList {...props} />,
    TAB: (props) => <ContainerTab {...props} />,
    TABLE: (props) => <ContainerTable {...props} />,
    TABLEGRID: (props) => <ContainerTableGrid {...props} />,
    WIDGETGRID: (props) => <WidgetGrid {...props} />,
    WIDGETLIST: (props) => <WidgetGrid {...props} />, // UWP-Alias auf VW WidgetGrid
    DROPDOWN: (props) => <ContainerDropdown {...props} />, 
    UNFALLDYNAMICCOLUMNS: (props) => (
        <UnfallDynamicColumnTableContainer {...props} />
    ), 
    HONEYCOMB: (props) => <ContainerHoneycomb {...props} />,
    DIALOG: (props) => <ContainerDialog {...props} />,
    FLEX: (props) => <ContainerFlex {...props} />,
    FLEXLIST: (props) => <ContainerFlexList {...props} />,
    FLEXTABS: (props) => <ContainerFlexTab {...props} />,
    OBJECTLIST: (props) => <ContainerObjectList {...props} />,
    STYLEDBOX: (props) => <ContainerStyledBox {...props} />,
    PAGINATION: (props) => <ContainerPagination {...props} />,
    PRINTPAGE: (props) => <PrintContainer {...props} />,
    UNORDEREDLISTCONTAINER: (props) => <UnorderedListContainer {...props} />,
    MANAGED_FLEX_CONTAINER: (props) => <ContainerManagedFlexContainer {...props} />,
    MANAGED_FLEX_ITEM: (props) => <ContainerManagedFlexItem {...props} />,
    ROOTDRAWER: (props) => <ContainerRootDrawer {...props} />,
    ROOTDIALOG: (props) => <RootDialog {...props} />,
    TABPROGRESSHEADER: (props) => <ContainerTabProgressHeader {...props} />,
    SORTABLELIST: (props) => <ContainerSortableList {...props} />,
    CARDCONTAINER: (props) => <CardContainer {...props} />,
    STYLEDTABLE: (props) => <ContainerStyledTable {...props} />,
    STYLEDTABLEGRID: (props) => <ContainerStyledTableGrid {...props} />,
    BAUSTEIN_REF: (props) => <ContainerBausteinRef {...props} />,
})
